import React from 'react';
import { Toast as BootstrapToast, ToastContainer } from 'react-bootstrap';

const Toast = ({ 
    children, 
    show = true, 
    onClose, 
    title, 
    delay = 3000, 
    autohide = true,
    bg,
    position = 'top-end',
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <ToastContainer position={position} className="p-3">
            <BootstrapToast 
                show={show} 
                onClose={onClose} 
                delay={delay} 
                autohide={autohide}
                bg={bg}
                className={className} 
                style={style}
                {...props}
            >
                {title && (
                    <BootstrapToast.Header>
                        <strong className="me-auto">{title}</strong>
                    </BootstrapToast.Header>
                )}
                <BootstrapToast.Body>{children}</BootstrapToast.Body>
            </BootstrapToast>
        </ToastContainer>
    );
};

export default Toast;

